import { PageHeaderType, type LayoutSpec } from '../../../../types/LayoutConfig';
import { DEFAULT_DEALER_SPACE_DATE_RANGE_VALUE } from '../../Panels/Dealer/DealerSpaceParameters';
import { DEALER_EXECUTION_AND_PRICING_LAYOUT_ID, DEALER_EXECUTION_AND_PRICING_LAYOUT_TEMPLATE_ID } from '../tokens';
import { EXECUTION_AND_PRICING_LAYOUT } from './ExecutionAndPricing';

export const EXECUTION_AND_PRICING_LAYOUT_SPEC: LayoutSpec = {
  templateId: DEALER_EXECUTION_AND_PRICING_LAYOUT_TEMPLATE_ID,
  label: 'Execution and Pricing',
  id: DEALER_EXECUTION_AND_PRICING_LAYOUT_ID,
  pageHeader: PageHeaderType.DealerSpaceParameters,
  dockViewLayout: EXECUTION_AND_PRICING_LAYOUT,
  spaceParameterValues: {
    DateRange: DEFAULT_DEALER_SPACE_DATE_RANGE_VALUE,
  },
  constraints: [],
  collapsablePanels: [],
};
